import { ExecutionEnvironment } from './ExecutionEnvironment'

const epicManagerModule = ExecutionEnvironment.isSsr ? undefined : require('@/redux/rootEpic')

//eslint-disable-next-line @typescript-eslint/no-explicit-any
const addNewEpicsLazily = (epicsArr: any[]) => {
  if (!epicManagerModule) {
    return
  }

  // epicRegistry может быть не готов на момент добавления эпика
  setTimeout(() => {
    const { epicRegistry, epic$ } = epicManagerModule

    epicsArr.forEach(epic => {
      if (!epicRegistry.includes(epic)) {
        epicRegistry.push(epic)
        epic$.next(epic)
      }
    })
  })
}

export { addNewEpicsLazily }
